/**
 * Shared auth/config for the hands-free voice co-pilot's token mint.
 * Mirrors the webSocketConfig built in EpisodePage.createGameServices:
 * auth via "Authorization: GameToken {jwt}" against /api/realtime-ws/token.
 */

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.selna.ai';

export function navApiBaseUrl(): string {
  return API_BASE_URL + '/api';
}

export function navAuthHeaders(token: string): () => Record<string, string> {
  return () => ({
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `GameToken ${token}` } : {}),
  });
}
